import { setReKycApplicationStep, useOnboarding } from "src/store/features/onboarding.slice";
import { BackButton, NextButton } from "./styled-components/Buttons";
import { Grid } from "@mui/material";
import { useAppDispatch } from "src/store/store";
import { useUserSlice } from "src/store/features/user.slice";
import { FormikValues, useFormikContext } from "formik";

export default function ReKycNavigation() {
  const { reKycApplicationStep, uploadedFiles, address, doesNotHoldSSN, ssn } = useOnboarding();
  const {
    reKycDetails: { recordType },
    salesforceDetails: { submitted },
  } = useUserSlice();
  const dispatch = useAppDispatch();
  const formik = useFormikContext<FormikValues>();
  const { validateForm, submitForm, setErrors } = formik;

  const handleSubmit = async () => {
    // Destructuring for 'About You'
    const {
      firstName,
      lastName,
      occupation,
      nationality,
      country,
      state,
      postCode,
      streetAddress,
      unitApartment,
      city,
      ssn: ssnError,
    } = await validateForm();

    // Destructuring for 'Entity'
    const {
      reKycEntityId,
      registeredOfficeCountry,
      registeredOfficeStreet,
      registeredOfficeunitApartment,
      registeredOfficeState,
      registeredOfficePostcode,
      placeOfBusinessCountry,
      placeOfBusinessStreet,
      placeOfBusinessunitApartment,
      placeOfBusinessState,
      placeOfBusinessPostCode,
    } = await validateForm();

    // Check if there is at least 1 file uploaded
    const minimunFileRequired = uploadedFiles.length > 0;

    // check if any of the files are loading
    const anyOfTheFilesIsLoading = uploadedFiles.some((file) => file.isLoading);

    // check if any of the files are loading
    const anyOfTheFilesContainsErrors = uploadedFiles.some((file) => file.isError);

    const containErrors =
      firstName ||
      lastName ||
      occupation ||
      nationality ||
      country ||
      state ||
      postCode ||
      streetAddress ||
      unitApartment ||
      ssnError ||
      anyOfTheFilesContainsErrors ||
      !minimunFileRequired ||
      reKycEntityId ||
      anyOfTheFilesIsLoading ||
      registeredOfficeCountry ||
      registeredOfficeStreet ||
      registeredOfficeunitApartment ||
      registeredOfficeState ||
      registeredOfficePostcode ||
      placeOfBusinessCountry ||
      placeOfBusinessStreet ||
      placeOfBusinessunitApartment ||
      placeOfBusinessState ||
      placeOfBusinessPostCode ||
      city;

    //

    if ((nationality === "American" || address.country === "United States") && !submitted) {
      if (!doesNotHoldSSN) {
        if (!ssn) return setErrors({ ssn: "SSN is required" });
      }
    }

    switch (reKycApplicationStep) {
      case "aboutYou":
        if (!minimunFileRequired) return window.alert("Please upload at least one Document");
        if (anyOfTheFilesContainsErrors) return window.alert("One or more files are invalid");
        if (anyOfTheFilesIsLoading) return window.alert("Please wait until the files are uploaded");
        if (recordType === "Individual" && !containErrors) {
          submitForm();
        } else {
          if (!containErrors) {
            dispatch(setReKycApplicationStep("aboutYourEntity"));
          }
        }
        break;
      case "aboutYourEntity":
        if (!containErrors) {
          submitForm();
        }
        break;
      default:
        break;
    }
  };

  const handleBackButton = () => {
    switch (reKycApplicationStep) {
      case "aboutYourEntity":
        dispatch(setReKycApplicationStep("aboutYou"));
        break;
      default:
        break;
    }
  };

  return (
    <Grid style={{ display: "flex", justifyContent: "space-between", padding: "20px" }}>
      <Grid item xs={6}>
        {reKycApplicationStep === "aboutYourEntity" && (
          <BackButton type={"button"} variant={"outlined"} onClick={handleBackButton}>
            Back
          </BackButton>
        )}
      </Grid>
      <Grid item xs={6}>
        {reKycApplicationStep !== "onfidoVerify" && (
          <NextButton type={"button"} onClick={handleSubmit}>
            {reKycApplicationStep === "aboutYou" && recordType === "Individual" && "Submit"}
            {reKycApplicationStep === "aboutYou" && recordType !== "Individual" && "Next"}
            {reKycApplicationStep === "aboutYourEntity" && "Submit"}
          </NextButton>
        )}
      </Grid>
    </Grid>
  );
}
